import React from "react";

import { InvestorSectionIcon } from "./InvestorMetricIcons";
import { historySectionIcon } from "../../utils/historyModuleConfig";

export default function HistoryTabLabel({ sectionId, children }) {
  const icon = historySectionIcon(sectionId);
  return (
    <span className="history-dash__tab-label">
      {icon ? (
        <span className="history-dash__tab-icon" aria-hidden>
          <InvestorSectionIcon name={icon} />
        </span>
      ) : null}
      <span>{children}</span>
    </span>
  );
}
